{
  "basicTerms": {
    "selectedOfTotal": "{selected}/{total} Dipilih",
    "search": "Cari",
    "summary": "Ringkasan",
    "insights": "Wawasan",
    "help": "Bantuan",
    "expand": "Perluas",
    "collapse": "Ciutkan",
    "menu": "Menu",
    "account": "Akun",
    "logout": "Keluar",
    "signIn": "Masuk",
    "days": "Hari | Hari",
    "phone": "Telepon",
    "subscribers": "Pelanggan | Pelanggan",
    "favorites": "Favorit | Favorit",
    "others": "Lainnya | Lainnya",
    "yes": "Ya",
    "no": "Tidak",
    "locations": "Lokasi | Lokasi",
    "active": "Aktif",
    "inactive": "Tidak aktif",
    "all": "Semua",
    "view": "Lihat",
    "language": "Bahasa",
    "required": "Wajib",
    "timezone": "Zona waktu",
    "new": "Baru",
    "open": "Buka",
    "close": "Tutup",
    "closed": "Tutup",
    "occupied": "Terisi",
    "reserved": "Dipesan",
    "enabled": "Diaktifkan",
    "disabled": "Dinonaktifkan",
    "enable": "Aktifkan",
    "disable": "Nonaktifkan",
    "print": "Cetak",
    "download": "Unduh",
    "zoomIn": "Perbesar",
    "zoomOut": "Perkecil",
    "previous": "Sebelumnya",
    "next": "Berikutnya",
    "version": "Versi",
    "setup": "Pengaturan",
    "caution": "Perhatian",
    "notes": "Catatan | Catatan",
    "add": "Tambah",
    "remove": "Hapus",
    "duration": "Durasi",
    "link": "Tautkan",
    "unlink": "Lepaskan tautan",
    "to": "Ke",
    "success": "Berhasil",
    "error": "Kesalahan",
    "info": "Info",
    "warning": "Peringatan",
    "time": "Waktu",
    "saved": "Tersimpan",
    "forms": "Formulir | Formulir",
    "is": "adalah",
    "only": "Hanya",
    "saving": "Menyimpan",
    "text": "teks",
    "zip": "zip",
    "spreadsheet": "spreadsheet",
    "image": "Gambar",
    "cloning": "Menggandakan",
    "clone": "Gandakan",
    "added": "Ditambahkan",
    "removed": "Dihapus",
    "planned": "Terencana",
    "unplanned": "Tidak terencana",
    "checkedIn": "Sudah Check-in",
    "checkedOut": "Sudah Check-out",
    "more": "Lainnya",
    "okay": "Oke",
    "reschedule": "Jadwalkan ulang",
    "results": "Hasil | Hasil",
    "none": "Tidak ada",
    "pages": "Halaman | Halaman",
    "pageOfTotal": "Halaman {current} dari {total}",
    "of": "dari",
    "default": "Default",
    "soon": "segera",
    "grid": "Kisi",
    "list": "Daftar",
    "booked": "Dipesan",
    "arrivals": "Kedatangan | Kedatangan",
    "early": "Lebih awal",
    "late": "Terlambat",
    "onTime": "Tepat Waktu",
    "area": "Area | Area",
    "spot": "Petak",
    "single": "Tunggal",
    "multiple": "Beberapa",
    "filter": "Filter",
    "board": "Papan",
    "at": "pada",
    "from": "Dari",
    "recent": "Terbaru",
    "delivered": "Terkirim",
    "sent": "Dikirim",
    "failed": "Gagal",
    "create": "Buat",
    "tasks": "Tugas | Tugas",
    "emails": "Email | Email",
    "passwords": "Kata sandi | Kata sandi",
    "limits": "Batas",
    "assignee": "Penerima tugas",
    "comment": "Komentar",
    "issue": "Masalah",
    "urgent": "Mendesak",
    "retry": "Coba lagi",
    "custom": "Kustom",
    "na": "T/A"
  },
  "phrases": {
    "updateEmail": "Perbarui Email",
    "copyToClipboard": "Salin ke Papan Klip",
    "copiedToClipboard": "Disalin ke Papan Klip",
    "warehouseAddress": "Alamat gudang",
    "cloneSchedule": "Gandakan Jadwal",
    "open24Hours": "Buka 24 Jam",
    "featureEnabled": "Fitur Diaktifkan",
    "featureDisabled": "Fitur Dinonaktifkan",
    "learnMore": "Pelajari lebih lanjut",
    "minuteLabel": "{minutes} MNT",
    "minuteLabelFull": "{minutes} menit",
    "thisActionCannotBeUndone": "tindakan ini TIDAK DAPAT dibatalkan",
    "areYouSure": "Apakah Anda yakin?",
    "unknownUser": "Pengguna tidak dikenal",
    "leaveWithoutSaving": "Keluar Tanpa Menyimpan",
    "learnHowItWorks": "Pelajari cara kerjanya",
    "allFields": "Semua Kolom",
    "selectColumns": "Pilih kolom",
    "selectedColumns": "Kolom terpilih",
    "addFiles": "Tambahkan file | Tambahkan file",
    "tasks": "Tidak ada tugas | {count} tugas | {count} tugas",
    "driversSelfCheckin": "Check-in mandiri pengemudi",
    "addReferenceNumber": "Tambahkan nomor referensi",
    "myAccount": "Akun Saya"
  },
  "messages": {
    "theConfirmationFieldDoesNotSupportPasting": "Kolom konfirmasi tidak mendukung fitur tempel",
    "youMayHaveUnsavedChangesAreYouSureYouWantToLeaveThisPage": "Mungkin ada perubahan yang belum disimpan, apakah Anda yakin ingin meninggalkan halaman ini?",
    "browserDoesNotSupportCopyFunction": "Browser tidak mendukung fungsi salin",
    "permissionToAccessClipboardWasDeniedToEnableAccessUpdateYourBrowserSettings": "Izin akses ke papan klip ditolak. Untuk mengaktifkan akses, perbarui pengaturan browser Anda.",
    "alternativelyYouCanManuallyCopy": "Sebagai alternatif, Anda dapat menyalin secara manual",
    "areYouSureYouWantToLeaveYouMayHaveUnsavedChanges": "Apakah Anda yakin ingin keluar? Mungkin ada perubahan yang belum disimpan.",
    "noResultsFound": "Tidak ada hasil ditemukan",
    "maximumOfReferenceNumbersAllowedCountRemoved": "Maksimum {maxItems} nomor referensi diperbolehkan. {removedCount} dihapus"
  },
  "fileFormats": {
    "jpeg": "jpeg",
    "jpg": "jpg",
    "png": "png",
    "webp": "webp",
    "pdf": "pdf"
  },
  "specialtyTerms": {
    "opendock": "Opendock",
    "warehouses": "Gudang | Gudang",
    "carrierContacts": "Kontak Pengangkut | Kontak Pengangkut",
    "loadTypes": "Jenis Muatan | Jenis Muatan",
    "docks": "Dok | Dok",
    "appointments": "Janji Temu | Janji Temu",
    "users": "Pengguna | Pengguna",
    "organizations": "Organisasi | Organisasi",
    "orgs": "Org | Org",
    "companies": "Perusahaan | Perusahaan",
    "referenceNumber": "Nomor Referensi",
    "refNumber": "Nomor Referensi",
    "status": "Status",
    "orgLoadTypes": "Jenis Muatan Org",
    "schedulingPortal": "Portal Penjadwalan",
    "customFields": "kolom kustom | kolom kustom",
    "interval": "Interval",
    "drivers": "Pengemudi | Pengemudi",
    "carriers": "Pengangkut | Pengangkut",
    "tags": "Tag | Tag",
    "yardManagement": "Manajemen Yard",
    "carrier": "pengangkut | pengangkut",
    "assets": "Aset | Aset",
    "tvMode": "Mode TV",
    "gridView": "Tampilan Kisi",
    "listView": "Tampilan Daftar",
    "gateManagement": "Manajemen Gerbang",
    "selfCheckIn": "check-in mandiri",
    "gateFeed": "Umpan Gerbang"
  },
  "appointmentStatuses": {
    "NoShow": "Tidak Hadir",
    "Cancelled": "Dibatalkan",
    "Requested": "Diminta",
    "Scheduled": "Terjadwal",
    "Arrived": "Tiba",
    "InProgress": "Dalam Proses",
    "Completed": "Selesai",
    "Reserves": "Reservasi"
  },
  "appointmentTypes": {
    "standard": "Standar",
    "reserved": "Direservasi",
    "reserve": "Reservasi"
  },
  "appointmentCreatorTypes": {
    "warehouseUser": "Pengguna Gudang",
    "carrier": "Pengangkut"
  },
  "roles": {
    "base": "Dasar",
    "carrier": "Pengangkut",
    "carrierAdmin": "Admin Pengangkut",
    "spectator": "Pengamat",
    "attendant": "Petugas",
    "operator": "Operator",
    "admin": "Admin",
    "owner": "Pemilik",
    "internal": "Internal",
    "god": "Master"
  },
  "weekdays": {
    "sunday": "Minggu",
    "monday": "Senin",
    "tuesday": "Selasa",
    "wednesday": "Rabu",
    "thursday": "Kamis",
    "friday": "Jumat",
    "saturday": "Sabtu"
  },
  "weekdaysAbbr": {
    "sun": "Min",
    "mon": "Sen",
    "tue": "Sel",
    "wed": "Rab",
    "thu": "Kam",
    "fri": "Jum",
    "sat": "Sab"
  },
  "buttons": {
    "nevermind": "Batal",
    "select": "Pilih",
    "confirm": "Konfirmasi",
    "next": "Berikutnya",
    "previous": "Sebelumnya",
    "create": "Buat",
    "edit": "Ubah",
    "save": "Simpan",
    "send": "Kirim",
    "yesDelete": "Ya, Hapus",
    "skipCreation": "Lewati Pembuatan",
    "cancel": "Batalkan",
    "export": "Ekspor",
    "saveChanges": "Simpan perubahan",
    "exportData": "Ekspor data",
    "resetToDefault": "Kembalikan ke Default"
  },
  "tooltips": {
    "notAvailable": "Tidak Tersedia",
    "notAvailableForUserRole": "Tidak tersedia untuk peran pengguna Anda."
  },
  "errors": {
    "unkownError": "Terjadi kesalahan yang tidak diketahui.",
    "thisFieldIsRequired": "Kolom ini wajib diisi",
    "passwordDoesNotMeetRequirements": "Kata sandi tidak memenuhi persyaratan kata sandi",
    "emailMustBeValid": "Email harus valid",
    "pleaseEnterAValidPhoneNumber": "Harap masukkan nomor telepon yang valid",
    "pleaseEnterAValidUrl": "Harap masukkan URL yang valid",
    "invalidHour": "Jam Tidak Valid",
    "invalidMinute": "Menit Tidak Valid",
    "pleaseSelectAmOrPm": "Pilih AM atau PM",
    "pleaseEnterACompleteDateAndTime": "Masukkan tanggal dan waktu lengkap",
    "mustBeANumber": "Harus berupa angka",
    "mustBeAPositiveInteger": "Harus berupa bilangan bulat positif",
    "mustBeAWholeNumber": "Harus berupa bilangan bulat",
    "isNotAValidNumber": "bukan angka yang valid",
    "isNotValid": "tidak valid",
    "invalidUuid": "UUID tidak valid",
    "dateMustNotBeInThePast": "Tanggal tidak boleh di masa lalu",
    "mustBeWithin24HoursOfStartTime": "harus dalam 24 jam dari waktu mulai",
    "pleaseSelectAtLeast": "Harap pilih setidaknya {requiredCount} {itemName} | Harap pilih setidaknya {requiredCount} {itemName}",
    "cannotSelectMoreThan": "Tidak dapat memilih lebih dari {limit} {itemName} | Tidak dapat memilih lebih dari {limit} {itemName}",
    "fieldMustEqual": "Kolom harus sama dengan {value}",
    "mustBeXCharacters": "Harus {length} karakter | Harus {length} karakter",
    "mustBeAtLeastXCharacters": "Minimal {min} karakter | Minimal {min} karakter",
    "mustBeAtMostXCharacters": "Maksimal {max} karakter | Maksimal {max} karakter",
    "mustBeBetweenXAndYCharactersLong": "Panjang harus antara {min} dan {max} karakter",
    "mustBeNumberBetweenXAndY": "Harus berupa angka antara {min} dan {max}",
    "mustBeNumberGreaterThan": "Harus berupa angka yang lebih besar dari atau sama dengan {min}",
    "mustBeNumberLessThan": "Harus berupa angka yang kurang dari {max}",
    "mustHaveAtLeast8Characters": "Minimal 8 karakter",
    "mustContainUpperCaseAndLowerCase": "Harus mengandung huruf besar dan huruf kecil",
    "mustContainAtLeastOneLetter": "Harus mengandung setidaknya satu huruf",
    "mustContainAtLeastOneSpecialCharacter": "Harus mengandung setidaknya satu karakter khusus",
    "mustContainAtLeastOneNumber": "Harus mengandung setidaknya satu angka",
    "atLeastOneReferenceNumberIsRequired": "Setidaknya satu {refNumberDisplayName} wajib diisi",
    "mustBeAValidNumber": "Harus berupa angka yang valid"
  },
  "warehouseAmenities": {
    "lumperServices": "Layanan bongkar muat (lumper)",
    "overnightParking": "Parkir semalam",
    "driversRestroom": "Toilet pengemudi",
    "freeWiFi": "Wi-Fi gratis"
  },
  "warehousePPERequirements": {
    "safetyBoots": "Sepatu Keselamatan",
    "safetyGlasses": "Kacamata Keselamatan",
    "gloves": "Sarung Tangan",
    "hardHat": "Helm Keselamatan",
    "faceMask": "Masker Wajah",
    "noSmoking": "Dilarang Merokok",
    "longPants": "Celana Panjang",
    "longSleeves": "Lengan Panjang",
    "highVisibilityVest": "Rompi Visibilitas Tinggi",
    "hairAndBeardNet": "Jaring Rambut dan Jenggot"
  },
  "auditLog": {
    "header": "Log Audit",
    "viewAuditLog": "Lihat Log Audit",
    "noAuditLogEvents": "Tidak ada peristiwa log audit",
    "printedOn": "Dicetak pada {date}",
    "viewDetails": "Lihat detail",
    "snapshot": {
      "schedule": "Jadwal",
      "eta": "ETA",
      "emailSubscribers": "Pelanggan Email",
      "customFields": "Bidang Kustom",
      "statusTimes": "Waktu Status"
    },
    "timelineForAllUpdatesMadeToThis": "Linimasa semua pembaruan untuk",
    "hasTheWords": "mengandung kata",
    "eventsFromDate": "Peristiwa sejak tanggal",
    "searchEvents": "Cari Peristiwa",
    "by": "oleh",
    "appointmentUpdatesTimeline": "Linimasa pembaruan janji temu:",
    "moreUpdates": "{count} pembaruan lainnya",
    "emailSubscribersUpdated": "Pelanggan Email Diperbarui",
    "detailsUpdated": "Detail Diperbarui",
    "recurrenceCreated": "Pengulangan Dibuat",
    "recurrenceDeleted": "Pengulangan Dihapus",
    "rescheduled": "{label} Dijadwalkan Ulang",
    "etaUpdated": "ETA Diperbarui",
    "emailNotifications": "Notifikasi email",
    "carrierContactUpdated": "Kontak Pengangkut Diperbarui",
    "reserveTransferred": "Reservasi Dipindahkan",
    "tagsUpdated": "Tag Diperbarui",
    "scheduled": "{label} Dijadwalkan",
    "statusUpdated": "Status Diperbarui",
    "timeUpdated": "Waktu {arrived} Diperbarui",
    "dwellTimeUpdated": "Waktu Tinggal Diperbarui",
    "labelWithStatus": "{label} {status}",
    "arrivedLate": "terlambat {duration}",
    "everyXAtXUntilX": "Setiap {weekDays} pukul {endTime} hingga {endDate}",
    "opendockTeam": "Tim Opendock",
    "unknownUser": "Pengguna Tidak Dikenal",
    "deleted": "Dihapus",
    "hasBeenCleared": "telah dikosongkan",
    "actionUpdated": "diperbarui",
    "actionCreated": "Dibuat",
    "actionDeleted": "Dihapus",
    "noAction": "Tidak ada tindakan",
    "emptyValue": "Nilai kosong"
  },
  "timeline": {
    "createdTheTask": "membuat tugas",
    "startedTheTask": "memulai tugas",
    "blockedTheTask": "memblokir tugas",
    "unblockedTheTask": "membuka blokir tugas",
    "completedTheTask": "menyelesaikan tugas",
    "cancelledTheTask": "membatalkan tugas",
    "cancelledTheReserve": "membatalkan reservasi",
    "cancelledTheReservationForSpot": "membatalkan reservasi {areaName} - {spotCode} untuk tugas ini",
    "reservedSpotForThisTask": "mereservasi {areaName} - {spotCode} untuk tugas ini",
    "reservedTheSpot": "mereservasi petak",
    "reason": "Alasan: {reason}",
    "addedA": "menambahkan",
    "reportedAn": "melaporkan",
    "clearedThe": "menghapus",
    "flaggedTheTask": "menandai tugas",
    "flaggedTheTaskAs": "menandai tugas sebagai",
    "unflaggedTheTask": "menghapus tanda tugas",
    "unflaggedTheTaskAs": "menghapus tanda tugas sebagai",
    "updatedTheTask": "memperbarui tugas",
    "removedTask": "menghapus tugas",
    "attachments": "lampiran",
    "confirmedTheLocation": "mengonfirmasi lokasi",
    "reportedAsMissing": "melaporkan sebagai hilang",
    "noActivityYet": "Belum ada aktivitas",
    "noAssignee": "Belum ada penerima tugas",
    "failedToFetchYardTaskTimeline": "Gagal mengambil linimasa tugas yard",
    "failedToCreateComment": "Gagal membuat komentar"
  },
  "yardSpotStatusDialog": {
    "headers": {
      "actionThisSpot": "{action} Petak ini?"
    },
    "dropDownItems": {
      "cleaning": "Pembersihan",
      "underMaintenance": "Dalam Perawatan",
      "blockedByEquipment": "Terhalang Peralatan",
      "safetyInspection": "Inspeksi Keselamatan",
      "routineInspection": "Inspeksi Rutin",
      "reserved": "Direservasi",
      "repairsNeeded": "Perlu Perbaikan",
      "damage": "Kerusakan"
    },
    "labels": {
      "reason": "Alasan",
      "additionalNotes": "Catatan Tambahan"
    },
    "placeholders": {
      "selectAReason": "Pilih alasan",
      "enterAdditionalNotes": "Masukkan catatan tambahan"
    },
    "messages": {
      "thisSpotWillRemainUnavailable": "Petak ini akan tetap tidak tersedia untuk penempatan aset hingga diatur sebagai terbuka kembali.",
      "thisDoorWillBeSetAsOpen": "Pintu ini akan diatur sebagai terbuka dan akan tersedia kembali untuk penempatan aset.",
      "assetInTransitClosingWillBlockMove": "Aset {assetCode} sedang dalam perjalanan ke petak ini. Menutupnya akan menghalangi pemindahan untuk diselesaikan."
    }
  },
  "tasks": {
    "presenter": {
      "unassigned": "Belum ditugaskan",
      "noDueDate": "Tanpa tenggat waktu",
      "fromAnySpot": "Dari petak mana pun",
      "toAnySpot": "Ke petak mana pun",
      "anyAsset": "Aset apa pun",
      "types": {
        "move": "Pindah"
      },
      "status": {
        "toDo": "Akan Dikerjakan",
        "inProgress": "Dalam Proses",
        "completed": "Selesai",
        "canceled": "Dibatalkan"
      },
      "issue": "Masalah",
      "relatedEntity": {
        "spotArea": "Area",
        "spot": "Petak",
        "asset": "Aset"
      }
    }
  },
  "readyForPickupNotificationDialog": {
    "title": "Notifikasi Siap Diambil",
    "messages": {
      "body": "Kirim email ke kontak berikut untuk memberi tahu bahwa aset {assetContainerCode} siap diambil di {warehouseName}.",
      "notificationSent": "Notifikasi berhasil dikirim.",
      "notificationFailed": "Gagal mengirim notifikasi. Silakan coba lagi."
    },
    "labels": {
      "notifyTheseContacts": "Beri tahu kontak berikut:",
      "suggestedContacts": "Kontak yang disarankan:"
    },
    "buttons": {
      "skipNotification": "Lewati Notifikasi"
    }
  },
  "chipList": {
    "keys": {
      "enter": "enter",
      "tab": "tab"
    },
    "messages": {
      "pressEnterOrTabToActionEntity": "Tekan {enterKey} atau {tabKey} untuk {action} {entity}",
      "pressEnterOrTabToAddEmail": "Tekan {enterKey} atau {tabKey} untuk menambahkan email"
    },
    "placeholders": {
      "emailSubscribers": "Pelanggan Email"
    }
  }
}
